import { PopupTheme } from '../PopupStyles.css';
import { baseTheme } from './PopupBaseTheme.css';
import { multiVariantStyles } from './PopupVariants.css';

/*******************
 * Component Theme
 *******************/

const PopupRedwoodTheme: PopupTheme = {
  baseTheme,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { PopupRedwoodTheme };
